import { render, staticRenderFns } from "./documents-component.vue?vue&type=template&id=bf4b8c06&"
import script from "./documents-component.vue?vue&type=script&lang=ts&"
export * from "./documents-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports